<template>
  <el-select ref="select" v-model="data" class="im-select" v-bind="selectProps" popper-class="im-select-popper" :clearable="clearable" :loading="loading" @change="onChange">
    <el-option v-for="item in options" :key="item.value" :value="item[valueKey]" :label="item[labelKey]" :disabled="item.disabled">
      <div v-if="type === 'goods'" class="flex items-center relative px-8" @click="handleSelect($event, item[valueKey])">
        <im-icon v-if="data === item[valueKey]" class="mr-3 absolute left-[10px] top-2.5" icon="icon-selected"/>
        <img class="w-[24px] h-[24px]" :src="item.icon" alt="">
        <span class="ml-2">{{ item.label }}</span>
      </div>
      <div v-else class="relative px-8" @click="handleSelect($event, item[valueKey])">
        <im-icon v-if="data === item[valueKey]" class="mr-3 absolute left-[10px] top-2.5" icon="icon-selected" />
        <span>{{ item[labelKey] }}</span>
      </div>
    </el-option>
    <slot name="append" />
  </el-select>
</template>

<script>
import { Select } from 'element-ui'
import { insertStep } from "~/utils/event";
export default {
  props: {
    ...Select.props,
    value: [String, Number, Array],
    clearable: {
      type: Boolean,
      default: false
    },
    targetKey: {
      type: String,
      default: ''
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    loading: Boolean,
    options: {
      type: Array,
      default() {
        return []
      }
    },
    isPageSelect: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      data: this.value
    }
  },
  computed: {
    selectProps() {
      const nonNative = ['options']
      const props = {}
      for (const key in this.$props) {
        if (!nonNative.includes(key)) {
          props[key] = this.$props[key]
        }
      }
      return props
    }
  },
  watch: {
    value(n) {
      this.data = n
    }
  },
  mounted() {
    this.data = this.value
  },
  methods: {
    emitValue(value) {
      this.$emit('input', value)
    },
    handleSelect(event, value) {
      if (this.$store.state.site.isChange && this.isPageSelect) {
        this.$emit('show-confirm-modal', value)
        event.stopPropagation()
      }
    },
    onChange(value) {
      this.targetKey && insertStep(this, [this.targetKey], this.value)
      this.emitValue(value)
      this.$emit('change', value)
    },
    blur() {
      this.$refs.select.blur()
    }
  }
}
</script>

<style lang="less">
.im-select-popper {
  background: rgba(30, 30, 35, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 6px;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4) !important;
  margin-top: 8px !important;

  div.popper__arrow {
    display: none;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background: rgba(255, 255, 255, 0.08) !important;
  }
  .el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.8);
    height: 36px;
    line-height: 36px;
    font-size: 13px;
    border-radius: 8px;
    padding: 0;
    min-width: 120px;
    margin-bottom: 2px;
    transition: all 0.2s;
    
    &:hover {
      background: rgba(255, 255, 255, 0.08) !important;
      color: white;
    }
  }
  .el-select-dropdown__item.selected {
    background: linear-gradient(90deg, rgba(var(--primary-color-rgb), 0.2), rgba(var(--primary-color-rgb), 0.1)) !important;
    color: var(--primary-color);
    font-weight: 600;
    
    &.hover {
      background: linear-gradient(90deg, rgba(var(--primary-color-rgb), 0.25), rgba(var(--primary-color-rgb), 0.15)) !important;
    }

    .icon-selected {
      color: var(--primary-color);
    }
  }
  .el-select-dropdown__item.is-disabled {
    color: rgba(255, 255, 255, 0.3);
    &:hover {
      background-color: transparent !important;
    }
  }
}

.im-select {
  width: 100%;
  
  .el-input__inner {
    background: rgba(255, 255, 255, 0.05) !important;
    border-radius: 8px !important;
    color: white !important;
    font-size: 13px;
    font-weight: normal;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    min-height: 36px !important;
    line-height: 36px !important;
    // transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding-left: 12px;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
    }
  }

  .el-input__suffix {
    .el-input__icon {
      color: rgba(255, 255, 255, 0.4);
      line-height: 36px;
    }
  }

  &:hover {
    .el-input__inner {
      background: rgba(255, 255, 255, 0.08) !important;
      border-color: rgba(255, 255, 255, 0.2) !important;
    }
  }

  &.el-select .el-input.is-focus .el-input__inner,
  &.el-select .el-input__inner:focus {
    border-color: var(--primary-color) !important;
    background: rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb), 0.2);
  }
}
</style>
